console.log("site-child.js");

// css
import "../scss/style.scss";
//import '../scss/woocommerce/scss/woocommerce.scss'

// page builder framework theme js
//import './modules/page-builder-framework.js';
import "./modules/site-min.js";

// slick carousel
//_____________________________________________________________
import slick from "slick-carousel";
import carouselSlider from "./modules/slick-carousel.js";
var carousel = new carouselSlider();

// smooth scrollbar
//_____________________________________________________________

/*
import Scrollbar from 'smooth-scrollbar';
var fixedElem = document.querySelector('.wpbf-menu-full-screen');
var scrollbar = Scrollbar.init(document.querySelector('body'), {
  damping: 0.07,
  alwaysShowTracks: false,
  thumbMinSize: 30,
});
scrollbar.addListener(function (status) {
  var offset = status.offset;
  fixedElem.style.top = offset.y + 'px';
  fixedElem.style.left = offset.x + 'px';
});
*/

// scroll magic
//_____________________________________________________________
import "./modules/scrollmagic.js";

// non va tramite modulo es6
//_____________________________________________________________
/*
import carouselSliderGallery from './modules/slick-carousel-gallery.js';
var carouselGallery = new carouselSliderGallery();
*/

// cookie consent js
//_____________________________________________________________
//console.log("cookieconsent.min.js");
//import './modules/cookieconsent.min.js';

// READMORE.JS
//_____________________________________________________________
import Readmore from "readmore-js";

//MODIFICA PIKADAY

(function ($) {
  $(document).ready(function () {
    //READMORE.JS
    $(".leggitutto .elementor-widget-container").readmore({
      speed: 100,
      collapsedHeight: 0,
      embedCSS: false,
      lessLink: '<a href="#" class="read-more chiudi"></a>',
      heightMargin: 0,
      moreLink: '<a href="#" class="read-more continua"></a>',
    });

    $(".widget-image-caption").each(function () {
      $(this).parent().find("a").append($(this));
    });

    // Add smooth scrolling to all links
    // $("a").on("click", function (event) {
    //   // Make sure this.hash has a value before overriding default behavior
    //   if (this.hash !== "") {
    //     // Prevent default anchor click behavior
    //     event.preventDefault();

    //     // Store hash
    //     var hash = this.hash;
    //     var target = $(hash);

    //     // Check if the target element exists
    //     if (target.length) {
    //       // Using jQuery's animate() method to add smooth page scroll
    //       // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
    //       $("html, body").animate(
    //         {
    //           scrollTop: target.offset().top,
    //         },
    //         200,
    //         function () {
    //           // Add hash (#) to URL when done scrolling (default click behavior)
    //           window.location.hash = hash;
    //         }
    //       );
    //     }
    //   } // End if
    // });

    //THUMBS GALLERY SLIDER
    /*
    $('.flex-control-nav').slick({
      autoplay: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      arrows: true,
      infinite: true,
    });
    */
  });
})(jQuery);

// * modifica marzo 2025 per inserire gallerie con nome sovrapposto nei blocchi spazi interni
document.addEventListener("DOMContentLoaded", function () {
  const ariaLabelContainers = Array.from(
    document.getElementsByClassName("elementor-image-carousel-wrapper")
  );

  ariaLabelContainers.forEach((element) => {
    element.classList.add("arialabel");

    const ariaLabel = element.getAttribute("aria-label");
    if (ariaLabel && ariaLabel.trim() !== "") {
      element.style.position = "relative";
      element.insertAdjacentHTML(
        "afterbegin",
        `<figcaption class="aria-label-text">${ariaLabel}</figcaption>`
      );
    }
  });
});
